import { Role } from '@dispatch/shared/types';

export const useGetUserRoleOptions = (roles: Role[]) => {
  const companyRoleOptions = roles?.map((role: Role) => {
    return { value: role.id, title: role?.name || '' };
  });

  return {
    companyUserRoles: companyRoleOptions,
  };
};
